import { render, staticRenderFns } from "./TestComponent1.vue?vue&type=template&id=3b3a7208&"
import script from "./TestComponent1.vue?vue&type=script&lang=ts&"
export * from "./TestComponent1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports